import axios from 'axios'
import * as utils from './api-utils'

export default {
  index() {
    return axios.get(utils.getApiUrl('/poles'))
  },
  update(id, data) {
    return axios.put(utils.getApiUrl(`/poles/${id}`), data)
  },
  updatePoleNumber(id, data) {
    return axios.put(utils.getApiUrl(`/poles/${id}`), {
      pole_number: data.pole_number,
      skipUsernameUpdate: data.skipUsernameUpdate,
    })
  },
}
